import { FC } from 'react'
import { useAuth } from '../../../../app/modules/auth'
import { KTIcon } from '../../../helpers'
import { UserMenu } from '../user-menu/UserMenu'
import AccountAvatarImage from '../../../helpers/components/Avatar'

const AsideUserMenu: FC = () => {
  const { currentUser } = useAuth()

  return (
    <>
      <div className='d-flex flex-stack card rounded-pill d-none d-lg-block'>
        {/* begin::User menu */}
        <div
          className='btn btn-active-color-primary py-1 ps-1 pe-3 w-100'
          data-kt-menu-trigger='click'
          data-kt-menu-overflow='false'
          data-kt-menu-placement='bottom-end'
        >
          {/* begin::Wrapper */}
          <div className='d-flex justify-content-between align-items-center'>
            {/* begin::Avatar */}
            <div className='symbol symbol-circle symbol-45px'>
              <AccountAvatarImage size={90} />
            </div>
            {/* end::Avatar */}
            <div className='d-flex flex-fill'>
              {/* begin::User info */}
              <div className='ms-2 text-start'>
                <span className='text-dark fs-6 fw-bolder lh-1'>
                  {currentUser?.first_name}
                </span>
                <span className='text-muted fw-bold d-block fs-7 lh-1'>{currentUser?.last_name}</span>
              </div>
              {/* end::User info */}
            </div>
            {/* end::Wrapper */}
            <div className='d-flex mt-1'>
              <KTIcon iconName='setting-2' className='fs-1' />
            </div>
          </div>
        </div>
        <UserMenu />
        {/* end::User menu */}
      </div>
    </>
  )
}

export { AsideUserMenu }
